<mat-menu class="studio-switcher" #studioListMenu="matMenu" x-position="before">
  <button mat-menu-item routerLink="/studio/{{currentStudio?.id}}">
    <b>{{currentStudio?.name}}</b>
  </button>
  @if (studioList && studioList.length > 1) {
    <hr>
      @for (studio of studioList; track studio?.id) {
        @if (studio?.id !== currentStudio?.id) {
          <button mat-menu-item (click)="selectStudioFromMenu.emit(studio)">
            <span style="font-size: 14px;">Switch to: <b>{{getName(studio)}}</b></span>
          </button>
        }
      }
    }
    <hr>
      @if (currentStudio) {
        <button mat-menu-item routerLink="{{'studio/'+currentStudio.id+'/edit-account'}}">Edit Account</button>
      }
      @if (!currentStudio) {
        <button mat-menu-item routerLink="edit-account">Edit Account</button>
      }
      <a mat-menu-item href="https://support.synconset.com/category/7e9j3qg4rq-asset-hub" target="_blank"
      alt="Help Desk">Help & Support</a>
      <button mat-menu-item (click)="lightSwitch.emit()">Lights
        @if (dark) {
          <span>On</span>
        }
        @if (!dark) {
          <span>Out</span>
        }
      </button>
      <button mat-menu-item (click)="logout()">Logout</button>
      @if (version) {
        <hr>
        }
        @if (version) {
          <span class="version-tag">
            v{{version}}
          </span>
        }
      </mat-menu>
      <button mat-icon-button [matMenuTriggerFor]="studioListMenu">
        <mat-icon svgIcon="apps"></mat-icon>
      </button>
